import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from '../../Services/AxiosService';
import { CustomStringify } from "../../Helpers/CustomStringify";

export const fetchListFG = createAsyncThunk(
  "DesignNameList/fetchListFG",
  async (cmpdetail, { rejectWithValue }) => {

    try {
      const result = await GET(`/products/${cmpdetail?.key}`);
      return result?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message)
    }
  }
);

const DesignNameListSlice = createSlice({
  name: "DesignNameList",
  initialState: {
    result: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchListFG.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchListFG.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.result = action.payload;
      })
      .addCase(fetchListFG.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default DesignNameListSlice.reducer;
